import KpiCard from "@/components/base/KpiCard";
import DonutChart from "@/components/feature/DonutChart";
import SectionCard from "./SectionCard";
import { StackedBarChart, HBarList, SliceLegend } from "./charts";
import { ordersKpis, dailyServiceOrders, topServices, orderStatus } from "@/mocks/salesReports";

const serviceKeys = [
  { key: "carWash", name: "غسيل سيارات", color: "#00AAB7" },
  { key: "cleaning", name: "تنظيف منازل", color: "#27AE60" },
  { key: "laundry", name: "مغاسل ملابس", color: "#4A90D9" },
];

const statusSegments = orderStatus.map((s) => ({ label: s.name, pct: s.value, color: s.color }));

export default function OrdersTab() {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {ordersKpis.map((k) => (
          <KpiCard key={k.label} {...k} />
        ))}
      </div>

      <SectionCard title="عدد الطلبات اليومي" subtitle="موزّعة حسب نوع الخدمة">
        <StackedBarChart data={dailyServiceOrders} xKey="day" keys={serviceKeys} height={300} />
      </SectionCard>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <SectionCard title="أكثر الخدمات طلباً">
          <HBarList items={topServices} color="#00AAB7" suffix=" طلب" />
        </SectionCard>

        <SectionCard title="حالة الطلبات">
          <div className="flex flex-col items-center">
            <DonutChart segments={statusSegments} size={190} thickness={30} centerValue="92%" centerLabel="مكتمل" />
            <SliceLegend items={statusSegments} />
          </div>
        </SectionCard>
      </div>
    </div>
  );
}